/**
 * 未实现页占位 —— 任何未在本迭代落地的导航项都落到这里。
 *
 * 复用 docs/06-ICON-MAP.md §5 的导航语义：标题来自 NAV_GROUPS 的 label，
 * 说明来自其 purpose，让占位页承载「这个页将来负责什么」的信息，
 * 而不是渲染一个无意义的空壳。详情页（/licenses/:id）是特例，单独给文案。
 */
import { Link, useLocation, useParams } from 'react-router-dom';
import { Icon } from '../icons/Icon';
import { findNavItem } from '../app/navigation';
import { ICON_SIZE } from '../tokens';

export function PlaceholderPage() {
  const location = useLocation();
  const params = useParams();
  const pathname = location.pathname;

  const isLicenseDetail = pathname.startsWith('/licenses/') && params.id !== undefined;
  const navItem = findNavItem(pathname);

  const title = isLicenseDetail ? '授权详情' : (navItem?.label ?? '页面未找到');
  const purpose = isLicenseDetail
    ? '展示单条授权的生命周期时间线、设备清单、兑换记录与可用操作（暂停 / 恢复 / 续期 / 撤销）。详情页 P-11 待实现。'
    : (navItem?.purpose ?? '该路径尚未在导航中登记。');

  const backTo = isLicenseDetail ? '/licenses' : '/';
  const backLabel = isLicenseDetail ? '授权列表' : '运行概览';

  return (
    <div className="page-head">
      <div>
        <h1 className="page-head__title">{title}</h1>
        <p className="page-head__sub">{purpose}</p>
      </div>
      <div style={{ marginTop: 'var(--space-6)' }}>
        <Link to={backTo} className="btn">
          <Icon name="chevron-right" size={ICON_SIZE.inline} className="pager__prev-icon" />
          返回{backLabel}
        </Link>
      </div>
    </div>
  );
}
